import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, LinkedinIcon, MapPinIcon } from 'lucide-react';
import { ThreeBackground } from '../components/ThreeBackground';
import { PageTransition } from '../components/PageTransition';
export function ContactPage() {
  return <PageTransition data-id="element-92">
      {/* Hero Header */}
      <section className="relative bg-navy-900 pt-32 pb-28 overflow-hidden bg-glow" data-id="element-93">
        <ThreeBackground data-id="element-94" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-96">
            <span className="text-gold font-bold tracking-widest text-sm uppercase mb-2 block" data-id="element-97">
              Connect
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-98">
              Get in Touch
            </h1>
            <p className="text-lg md:text-xl text-white/80 leading-relaxed max-w-2xl mx-auto" data-id="element-99">
              Interested in discussing executive leadership opportunities in
              midstream operations, gas processing, or industrial management? I
              welcome the opportunity to connect.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="bg-light py-20" data-id="element-100">
        <div className="max-w-3xl mx-auto px-6 md:px-12 text-center" data-id="element-101">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16" data-id="element-102">
            <a href="mailto:dennissorce7@gmail.com" className="flex items-center justify-center px-10 py-5 bg-gold text-navy-900 font-bold tracking-wide text-lg hover:bg-gold-light transition-colors duration-300 w-full sm:w-auto rounded" data-id="element-103">
              <MailIcon className="mr-3" size={22} data-id="element-104" />
              Email Bryan
            </a>
            <a href="#" className="flex items-center justify-center px-10 py-5 border-2 border-navy-900 text-navy-900 font-bold tracking-wide text-lg hover:bg-navy-900 hover:text-white transition-colors duration-300 w-full sm:w-auto rounded" data-id="element-105">
              <LinkedinIcon className="mr-3" size={22} data-id="element-106" />
              LinkedIn Profile
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex items-center justify-center text-ink-muted font-medium text-lg mb-20" data-id="element-107">
            <MapPinIcon className="text-gold mr-3" size={22} data-id="element-108" />
            Based in Texas, United States
          </motion.div>

          {/* Contact Form Section - JotForm */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="max-w-2xl mx-auto" data-id="element-109">
            <div className="text-center mb-8" data-id="element-110">
              <h2 className="text-2xl font-bold text-ink mb-2" data-id="element-111">
                Send a Message
              </h2>
              <p className="text-ink-muted" data-id="element-112">
                Fill out the form below and I'll get back to you shortly.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-113">
              <iframe title="Contact Form" src="https://form.jotform.com/260727014819054" style={{
              width: '100%',
              minHeight: '540px',
              border: 'none'
            }} allowFullScreen data-id="element-114" />
            </div>
          </motion.div>

          {/* Additional context */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="mt-20 pt-16 border-t border-gray-200" data-id="element-115">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-116">
              Areas of Interest
            </h2>
            <div className="flex flex-wrap justify-center gap-3" data-id="element-117">
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-118">
                Midstream Operations
              </span>
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-119">
                Gas Processing
              </span>
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-120">
                Plant Management
              </span>
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-121">
                Executive Leadership
              </span>
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-122">
                Board Advisory
              </span>
              <span className="px-4 py-2 bg-navy-900 text-white text-sm font-medium rounded" data-id="element-123">
                Capital Projects
              </span>
            </div>
          </motion.div>
        </div>
      </section>
    </PageTransition>;
}